 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Authorization":"Authorization","Forbidden":"Forbidden","area-manager-dashboard~customer-detail~sa-orders~store-manager-orders":"area-manager-dashboard~customer-detail~sa-orders~store-manager-orders","area-manager-dashboard~sa-orders~store-manager-orders":"area-manager-dashboard~sa-orders~store-manager-orders","area-manager-dashboard~store-manager-dashboard":"area-manager-dashboard~store-manager-dashboard","area-manager-dashboard":"area-manager-dashboard","sa-orders":"sa-orders","store-manager-orders":"store-manager-orders","customer-detail":"customer-detail","auth-prompt":"auth-prompt","customer-order~order~sa-create~store-manager-dashboard":"customer-order~order~sa-create~store-manager-dashboard","store-manager-dashboard":"store-manager-dashboard","customer-order~order":"customer-order~order","customer-order":"customer-order","order":"order","sa-create":"sa-create","customer-paysuccess":"customer-paysuccess","logistics":"logistics","sa-customers~store-manager-customer":"sa-customers~store-manager-customer","sa-customers":"sa-customers","store-manager-customer":"store-manager-customer","sa-dashboard":"sa-dashboard","sa-my":"sa-my","select-store":"select-store","store-manager-my":"store-manager-my","store-manager-sales":"store-manager-sales"}[chunkId]||chunkId) + "." + {"Authorization":"a3a2b313","Forbidden":"36f301ad","area-manager-dashboard~customer-detail~sa-orders~store-manager-orders":"b95c5a83","area-manager-dashboard~sa-orders~store-manager-orders":"761b6179","area-manager-dashboard~store-manager-dashboard":"5d0df733","area-manager-dashboard":"2dd197dc","sa-orders":"e397282d","store-manager-orders":"15bcb4d5","customer-detail":"0e356542","auth-prompt":"f633b061","chunk-2d0c53c6":"82d8163b","chunk-4644f24c":"8802a45f","chunk-8322911e":"aca49023","chunk-b30fc5fc":"3769499d","customer-order~order~sa-create~store-manager-dashboard":"3ac3de04","store-manager-dashboard":"c4676fc9","customer-order~order":"de7e7a6e","customer-order":"d765cec3","order":"bb5db0b6","sa-create":"819782dc","customer-paysuccess":"04211f97","logistics":"44978d32","sa-customers~store-manager-customer":"9a473d4b","sa-customers":"f2d4995d","store-manager-customer":"7a341f9a","sa-dashboard":"5e70dcac","sa-my":"448b61e4","select-store":"88ebacd2","store-manager-my":"d83d542f","store-manager-sales":"50ed6461"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Forbidden":1,"area-manager-dashboard~customer-detail~sa-orders~store-manager-orders":1,"area-manager-dashboard~sa-orders~store-manager-orders":1,"area-manager-dashboard~store-manager-dashboard":1,"area-manager-dashboard":1,"customer-detail":1,"auth-prompt":1,"chunk-4644f24c":1,"chunk-8322911e":1,"chunk-b30fc5fc":1,"customer-order~order~sa-create~store-manager-dashboard":1,"store-manager-dashboard":1,"customer-order~order":1,"customer-order":1,"order":1,"sa-create":1,"customer-paysuccess":1,"logistics":1,"sa-customers~store-manager-customer":1,"sa-dashboard":1,"sa-my":1,"select-store":1,"store-manager-my":1,"store-manager-sales":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Authorization":"Authorization","Forbidden":"Forbidden","area-manager-dashboard~customer-detail~sa-orders~store-manager-orders":"area-manager-dashboard~customer-detail~sa-orders~store-manager-orders","area-manager-dashboard~sa-orders~store-manager-orders":"area-manager-dashboard~sa-orders~store-manager-orders","area-manager-dashboard~store-manager-dashboard":"area-manager-dashboard~store-manager-dashboard","area-manager-dashboard":"area-manager-dashboard","sa-orders":"sa-orders","store-manager-orders":"store-manager-orders","customer-detail":"customer-detail","auth-prompt":"auth-prompt","customer-order~order~sa-create~store-manager-dashboard":"customer-order~order~sa-create~store-manager-dashboard","store-manager-dashboard":"store-manager-dashboard","customer-order~order":"customer-order~order","customer-order":"customer-order","order":"order","sa-create":"sa-create","customer-paysuccess":"customer-paysuccess","logistics":"logistics","sa-customers~store-manager-customer":"sa-customers~store-manager-customer","sa-customers":"sa-customers","store-manager-customer":"store-manager-customer","sa-dashboard":"sa-dashboard","sa-my":"sa-my","select-store":"select-store","store-manager-my":"store-manager-my","store-manager-sales":"store-manager-sales"}[chunkId]||chunkId) + "." + {"Authorization":"31d6cfe0","Forbidden":"ffee573c","area-manager-dashboard~customer-detail~sa-orders~store-manager-orders":"4b3046cf","area-manager-dashboard~sa-orders~store-manager-orders":"ccdbd4fe","area-manager-dashboard~store-manager-dashboard":"fb3db7a5","area-manager-dashboard":"b894d680","sa-orders":"31d6cfe0","store-manager-orders":"31d6cfe0","customer-detail":"369472f3","auth-prompt":"826f93e9","chunk-2d0c53c6":"31d6cfe0","chunk-4644f24c":"00d5dd48","chunk-8322911e":"00d5dd48","chunk-b30fc5fc":"00d5dd48","customer-order~order~sa-create~store-manager-dashboard":"13da2980","store-manager-dashboard":"6c7540fc","customer-order~order":"0584a48c","customer-order":"bff9488f","order":"746f755a","sa-create":"20f0ac7d","customer-paysuccess":"79197160","logistics":"d9b7d88d","sa-customers~store-manager-customer":"738e0f2d","sa-customers":"31d6cfe0","store-manager-customer":"31d6cfe0","sa-dashboard":"0f2bef08","sa-my":"f533b37e","select-store":"e84e8cfe","store-manager-my":"1493d27c","store-manager-sales":"99d1b610"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/remote-sales-h5/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
